module.exports = __webpack_public_path__ + "static/media/stop-1.f066505a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-1.svg
// module id = 1346
// module chunks = 0